import React from 'react'

const CopyIcon = (props) => {
  const { width = 20, height = 20, fill = '#FFFFFF' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0998 13.2998C6.75147 13.2998 6.45328 13.1758 6.20522 12.9278C5.95717 12.6797 5.83314 12.3815 5.83314 12.0332V4.43317C5.83314 4.08484 5.95717 3.78664 6.20522 3.53859C6.45328 3.29053 6.75147 3.1665 7.0998 3.1665H12.7998C13.1481 3.1665 13.4463 3.29053 13.6944 3.53859C13.9424 3.78664 14.0665 4.08484 14.0665 4.43317V12.0332C14.0665 12.3815 13.9424 12.6797 13.6944 12.9278C13.4463 13.1758 13.1481 13.2998 12.7998 13.2998H7.0998ZM7.0998 12.0332H12.7998V4.43317H7.0998V12.0332ZM4.56647 15.8332C4.21814 15.8332 3.91994 15.7091 3.67189 15.4611C3.42383 15.213 3.2998 14.9148 3.2998 14.5665V5.69984H4.56647V14.5665H11.5331V15.8332H4.56647Z"
        fill={fill}
      />
    </svg>
  )
}

export default CopyIcon
